import PublicInfoForm from './PublicInfoForm'

export default PublicInfoForm
